import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { Track } from 'types/track'
import type { TrackStatus } from '@disco/state-management/reducers/media'
import {
  getTrackPlaybackStatus,
  getTrackPlaying,
} from '@disco/state-management/selectors/media'
import PlayTime from 'components/ui/play-time'
const DEFAULT_TRACK_STATUS = {} as TrackStatus

/**
 * Playback time component that displays current playback position and track duration
 * Shows formatted time display for the currently playing track with real-time updates
 */
const PlaybackTime = (): React.ReactNode => {
  const track: Track | null | undefined = useSelector(getTrackPlaying)
  const { playbackPosition }: TrackStatus =
    useSelector(state =>
      getTrackPlaybackStatus(state, {
        trackId: track?.id,
      }),
    ) ?? DEFAULT_TRACK_STATUS
  return <PlayTime max={track?.duration} time={playbackPosition} />
}

export default PlaybackTime
